module.exports = __webpack_public_path__ + "img/a.c97a1848.svg";